import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class NewArrivals extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    // gsap.set(this.el, { autoAlpha: 0 })
  }

  animate() {
    const products = qsa(".product", this.el)
    const title = qsa(".title-wrapper .char-0", this.el)
    const number = qs(".number", this.el)

    gsap.from(title, {
      y: 50,
      duration: 1.2,
      stagger: 0.03,
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })

    gsap.from(number, {
      y: 50,
      duration: 1.2,
      stagger: 0.03,
      scrollTrigger: {
        trigger: number,
        start: "top bottom",
      },
    })

    gsap.from(products, {
      y: 120,
      autoAlpha: 0,
      duration: 1.5,
      stagger: 0.1,
      scrollTrigger: {
        trigger: products,
        start: "top bottom",
      },
    })

    // gsap.set(this.el, { autoAlpha: 1 })
  }
}
